









































import { Component, Vue, Prop } from "vue-property-decorator";
import { firmRecommend } from "@/req/game";
import headerTitle from "@/components/headerTitle.vue";
import qs from "@/components/queSheng.vue";
@Component({
  components: { qs, headerTitle },
})
export default class Home extends Vue {
  public activeMenu = "";
  @Prop({ type: Number, default: null }) public factoryId;
  @Prop({ type: Number, default: null }) public boxGameId;
  public list = [
    // {
    //   box_game_id: 1,
    //   game_logo_url:
    //     "http://static.dhsf.xqhuyu.com/box_test/detaillogo/5faa4fd96c3b3.png",
    //   game_name: "耀光传奇",
    //   game_version_name: "1.85",
    //   game_tags: "火龙",
    //   game_hot_point: 25,
    //   game_score: "10",
    // },
  ];
  public mounted() {
    this.getList();
  }
  public async getList() {
    const obj = {
      token: this.$fn.cookies.getToken(),
      factory_id: this.factoryId,
      box_game_id: this.boxGameId,
    };
    const res = await firmRecommend(obj);
    if (res.code == 200) {
      this.list = res.data.game_list.data;
    }
  }
  public toTags(list) {
    if (!list) {
      return [];
    }
    if (!this.factoryId) {
      return [];
    }
    const arr = list.split("|");
    return arr;
  }
}
